import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface GlobalLoadingOverlayState {
  show: boolean;
  message: string;
}

const initialState: GlobalLoadingOverlayState = {
  show: false,
  message: "Loading...",
};

const globalLoadingOverlaySlice = createSlice({
  name: "globalLoadingOverlay",
  initialState,
  reducers: {
    showGlobalLoadingOverlay: (state, action: PayloadAction<{ message?: string }>) => {
      state.show = true;
      state.message = action.payload?.message || "Loading...";
    },
    hideGlobalLoadingOverlay: (state) => {
      state.show = false;
    },
  },
});

export const { showGlobalLoadingOverlay, hideGlobalLoadingOverlay } = globalLoadingOverlaySlice.actions;

export const getGlobalLoadingOverlayState = (state: RootState) => state.globalLoadingOverlay;

export default globalLoadingOverlaySlice.reducer; 